<template>
  <v-col cols=12>
    <moderator-tab-2-layouts
      :listProposals="listProposals"
      :preloaderYet="preloaderYet"
      @redirect-document="redirectDocumentTab($event)"
      @open-pdf="openPdf($event)"
      @open-modal-card="open_proposal_card($event)"
      @load-new-request="loadNewRequest($event[0], $event[1])"
      @upload-to-excel="uploadToExcel($event)">
    </moderator-tab-2-layouts>
  </v-col>

</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModeratorTab2Layouts from '../components/layouts/ModeratorTab2Layouts.vue';

export default {
  name: 'ModeratorTab2',
  components: {
    ModeratorTab2Layouts,
  },
  data() {
    return {
      listProposals: [],
      preloaderYet: false,
      statusList: [
        { status_id: 105, slug: 'draft', name: this.$t('ModeratorList.applications_still_being_formed'), page: 1 },
        { status_id: 2, slug: 'created', name: this.$t('ModeratorList.incoming_requests'), page: 1 },
        { status_id: 104, slug: 'expertise', name: this.$t('ModeratorList.on_examination'), page: 1 },
        // { status_id: 4, slug: 'statement', name: this.$t('ModeratorList.expert_advice'), page: 1 },
        // { status_id: 5, slug: 'approve', name: this.$t('ModeratorList.adopted'), page: 1 },
        // { status_id: 6, slug: 'modification', name: this.$t('ModeratorList.on_completion'), page: 1 },
        { status_id: 7, slug: 'scheduled', name: this.$t('ModeratorList.experiment_planned'), page: 1 },
        { status_id: 8, slug: 'need_report', name: this.$t('ModeratorList.awaiting_report'), page: 1 },
        { status_id: 9, slug: 'done', name: this.$t('ModeratorList.completed'), page: 1 },
        { status_id: 10, slug: 'publication', name: this.$t('ModeratorList.there_publication'), page: 1 },
        { status_id: 12, slug: 'deleted', name: this.$t('ModeratorList.deleted'), page: 1 },
        { status_id: 11, slug: 'reject', name: this.$t('ModeratorList.rejected'), page: 1 },
        { status_id: 14, slug:'not_realized', name: this.$t('ModeratorList.not_realized'), page: 1 },
        { status_id: 13, slug:'archived', name: this.$t('ModeratorList.archived'), page: 1 },
      ],
      current_index: 0,

      call_id: null,
    };
  },
  beforeMount() {
    this.loadNewRequest();
  },

  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
      'GETTERS_EXPER',
      'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
    ]),
  },

  methods: {
    ...mapActions([
      'GET_URL_PRD',
      'GET_LIST_ROLE_NEW',
      'GET_EXPER',
      'UPLOAD_LIST_TO_EXCEL',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      'SHOW_PROPOSAL_CARD',
    ]),
    loadNewRequest(index = 0, pageType = false) {
      const stop = false
      this.current_index = index

      pageType ? this.statusList[index].page++ : null;
      this.preloaderYet = true;
      if (this.statusList[index].page == 1) {
        this.listProposals = [];
      }

      this.GET_LIST_ROLE_NEW({
        status_id: this.statusList[index].status_id,
        page: this.statusList[index].page,
      })
        .then((res) => {
          this.preloaderYet = false;
          if (res.headers.pages == 1) {
          }
          this.listProposals = res.data;
        })
        .catch(() => this.preloaderYet = false);
      // }

      this.GET_EXPER();
    },
    
    redirectDocumentTab(request) {
      this.UPDATE_OVERLAY(true)
      const proposal = [];

      request.forEach((item) => {
        proposal.push(item.id);
      });

      this.GET_URL_PRD(proposal)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.proposal = [];
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
          this.proposal = [];
        });
    },
    uploadToExcel(request) {
      this.UPDATE_OVERLAY(true)
      const proposals = [];

      var type_id = request[1]
      request[0].forEach((item) => {
        proposals.push(item.id);
      });

      this.UPLOAD_LIST_TO_EXCEL({proposal_ids: proposals, type_id: type_id})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
        });
    },

    open_proposal_card(item) {
      this.call_id = new Date()
      this.SHOW_PROPOSAL_CARD({
        'proposal_id' : item.id,
        'call_id': this.call_id
      })
    },
    
    openPdf(id) {
      this.UPDATE_OVERLAY(true)
      this.GET_URL_PRD(id)
        .then(() => this.UPDATE_OVERLAY(false))
        .catch(() => this.UPDATE_OVERLAY(false));
    },
  },


  watch: {
    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
        this.loadNewRequest(this.current_index)
      }
    },
  }
};
</script>
